var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project"},[_c('a',{attrs:{"href":_vm.project.url}},[_vm._v(_vm._s(_vm.project.name)+" ("+_vm._s(_vm.yearText)+")")]),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.htmlDesc)}}),(_vm.project.code)?_c('small',[_c('a',{attrs:{"href":"project.code"}},[_vm._v("View Project on GitHub")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }